// Generated by ReScript, PLEASE EDIT WITH CARE
'use strict';

let Utils = require("../../../utils/Utils.bs.js");
let React = require("react");
let Loader = require("../../../uikit/reason/atoms/Loader/Loader.bs.js");
let Sentry = require("../../../reason/Sentry.bs.js");
let PageTitle = require("../../../reason/common/PageTitle.bs.js");
let LoggedInAgent = require("../../../reason/common/UserSession/LoggedInAgent.bs.js");
let MarkupHelpers = require("../../../reason/common/MarkupHelpers/MarkupHelpers.bs.js");
let Stdlib_Option = require("@rescript/runtime/lib/js/Stdlib_Option.js");
let ErrorComponent = require("../../../reason/common/Error/ErrorComponent.bs.js");
let ResizeObserver = require("../../../reason/common/ResizeObserver.bs.js");
let TailwindMerge = require("tailwind-merge");
let Primitive_option = require("@rescript/runtime/lib/js/Primitive_option.js");
let JsxRuntime = require("react/jsx-runtime");
let RescriptRelay_Query = require("rescript-relay/src/RescriptRelay_Query.bs.js");
let ReactErrorBoundary = require("react-error-boundary");
let ConversationsListRelay = require("./ConversationsListRelay.bs.js");
let ConversationsEmptyState = require("./ConversationsEmptyState.bs.js");
let ConversationsPageRelayCommon = require("./ConversationsPageRelayCommon.bs.js");
let ConversationPageNewConversation = require("./ConversationPageNewConversation.bs.js");
let ConversationsPageRelayQuery_graphql = require("../../../__generated__/ConversationsPageRelayQuery_graphql.bs.js");
let ConversationPageExistingConversation = require("./ConversationPageExistingConversation.bs.js");

function useDecodeSelectedConversation(slug) {
  let match = ConversationsPageRelayCommon.QueryParams.use();
  let queryParams = match[0];
  return React.useMemo(() => {
    if (slug === undefined) {
      return {
        TAG: "Ok",
        _0: undefined
      };
    }
    if (slug !== "new") {
      return {
        TAG: "Ok",
        _0: {
          TAG: "Existing",
          _0: slug
        }
      };
    }
    let id = queryParams.context_id;
    if (id !== undefined) {
      let contextType = queryParams.context_type;
      if (contextType !== undefined) {
        return {
          TAG: "Ok",
          _0: {
            TAG: "New",
            _0: contextType,
            _1: id
          }
        };
      }
    }
    return {
      TAG: "Error",
      _0: {
        message: `Could not decode the required query params got (` + Stdlib_Option.getOr(id, "") + `, ` + Stdlib_Option.getOr(Stdlib_Option.map(queryParams.context_type, ConversationsPageRelayCommon.EntityType.toString), "") + `) for new conversation`
      }
    };
  }, [
    slug,
    queryParams
  ]);
}

let SelectedConversation = {
  useDecodeSelectedConversation: useDecodeSelectedConversation
};

let convertVariables = ConversationsPageRelayQuery_graphql.Internal.convertVariables;

let convertResponse = ConversationsPageRelayQuery_graphql.Internal.convertResponse;

let convertWrapRawResponse = ConversationsPageRelayQuery_graphql.Internal.convertWrapRawResponse;

let use = RescriptRelay_Query.useQuery(convertVariables, ConversationsPageRelayQuery_graphql.node, convertResponse);

let useLoader = RescriptRelay_Query.useLoader(convertVariables, ConversationsPageRelayQuery_graphql.node, prim => prim);

let usePreloaded = RescriptRelay_Query.usePreloaded(ConversationsPageRelayQuery_graphql.node, convertResponse, prim => prim);

let fetch = RescriptRelay_Query.fetch(ConversationsPageRelayQuery_graphql.node, convertResponse, convertVariables);

let fetchPromised = RescriptRelay_Query.fetchPromised(ConversationsPageRelayQuery_graphql.node, convertResponse, convertVariables);

let retain = RescriptRelay_Query.retain(ConversationsPageRelayQuery_graphql.node, convertVariables);

let Query = {
  Operation: undefined,
  Types: undefined,
  convertVariables: convertVariables,
  convertResponse: convertResponse,
  convertWrapRawResponse: convertWrapRawResponse,
  use: use,
  useLoader: useLoader,
  usePreloaded: usePreloaded,
  fetch: fetch,
  fetchPromised: fetchPromised,
  retain: retain
};

function ConversationsPageRelay$Page(props) {
  let query = use(undefined, undefined, undefined, undefined);
  let selectedConversationId = useDecodeSelectedConversation(props.slug);
  let selectedId;
  if (selectedConversationId.TAG === "Ok") {
    let match = selectedConversationId._0;
    selectedId = match !== undefined && match.TAG === "Existing" ? match._0 : undefined;
  } else {
    selectedId = undefined;
  }
  let isNewConversation;
  if (selectedConversationId.TAG === "Ok") {
    let match$1 = selectedConversationId._0;
    isNewConversation = match$1 !== undefined ? match$1.TAG !== "Existing" : false;
  } else {
    isNewConversation = false;
  }
  let hasSelectedConversation = Stdlib_Option.isSome(selectedId);
  let mainElementRef = React.useRef(undefined);
  let match$2 = ResizeObserver.useElementSize(mainElementRef);
  let mainHeight = match$2[0];
  let hasConversations = query.conversationsCount.totalCount > 0 || isNewConversation;
  let tmp;
  if (hasConversations) {
    let tmp$1;
    if (selectedConversationId.TAG === "Ok") {
      let originalConversationId = selectedConversationId._0;
      tmp$1 = originalConversationId !== undefined ? (
          originalConversationId.TAG === "Existing" ? JsxRuntime.jsx(React.Suspense, {
              children: JsxRuntime.jsx("div", {
                children: JsxRuntime.jsx(ConversationPageExistingConversation.make, {
                  selectedConversationId: originalConversationId._0
                }),
                className: "bg-white rounded-md"
              }),
              fallback: JsxRuntime.jsx(Loader.make, {})
            }) : JsxRuntime.jsx(React.Suspense, {
              children: JsxRuntime.jsx("div", {
                children: JsxRuntime.jsx(ConversationPageNewConversation.make, {
                  entityType: originalConversationId._0,
                  entityId: originalConversationId._1,
                  originalConversationId: originalConversationId
                }),
                className: "bg-white"
              }),
              fallback: JsxRuntime.jsx(Loader.make, {})
            })
        ) : JsxRuntime.jsx(ConversationsPageRelayCommon.RecordPageView.ConversationsList.make, {});
    } else {
      tmp$1 = null;
    }
    tmp = JsxRuntime.jsx("div", {
      children: JsxRuntime.jsxs("div", {
        children: [
          JsxRuntime.jsx("div", {
            children: JsxRuntime.jsx("div", {
              children: JsxRuntime.jsx(ConversationsListRelay.make, {
                query: query.fragmentRefs,
                selectedConversationId: selectedId,
                isNewConversation: isNewConversation
              }),
              className: "rounded-md overflow-hidden min-h-[calc(100vh-250px)] lg:min-h-[calc(100vh-200px)] bg-white",
              style: {
                height: mainHeight !== 0 ? mainHeight.toString() + `px` : undefined
              }
            }),
            className: TailwindMerge.twMerge([
              isNewConversation || hasSelectedConversation ? "hidden lg:block" : "col-span-12",
              "lg:col-span-4 border-r lg:border-r-0"
            ])
          }),
          JsxRuntime.jsx("div", {
            children: tmp$1,
            ref: Primitive_option.some(e => {
              Utils.React.setCurrentRef(mainElementRef, (e == null) ? undefined : Primitive_option.some(e));
            }),
            className: TailwindMerge.twMerge([
              isNewConversation || hasSelectedConversation ? "col-span-12" : "hidden lg:block",
              "lg:col-span-8 min-h-[200px] h-full bg-white lg:bg-transparent"
            ])
          })
        ],
        className: "grid grid-cols-12 lg:gap-6"
      }),
      className: TailwindMerge.twMerge(["w-full max-w-full -mt-6 lg:mt-0 lg:mx-auto lg:max-w-[960px] xl:max-w-[1140px] 2xl:max-w-[1320px]"])
    });
  } else {
    tmp = JsxRuntime.jsx(ConversationsEmptyState.make, {});
  }
  return JsxRuntime.jsxs(JsxRuntime.Fragment, {
    children: [
      JsxRuntime.jsx(PageTitle.make, {
        title: "Conversations"
      }),
      tmp
    ]
  });
}

let Page = {
  make: ConversationsPageRelay$Page
};

let defaultMessage = "There was a problem loading your conversations. Please refresh or try again later.";

function ConversationsPageRelay$ErrorState(props) {
  let __message = props.message;
  let message = __message !== undefined ? __message : defaultMessage;
  return JsxRuntime.jsx(MarkupHelpers.Container.make, {
    children: JsxRuntime.jsx(ErrorComponent.make, {
      message: message
    })
  });
}

let ErrorState = {
  defaultMessage: defaultMessage,
  make: ConversationsPageRelay$ErrorState
};

function ConversationsPageRelay(props) {
  return JsxRuntime.jsx(ReactErrorBoundary.ErrorBoundary, {
    FallbackComponent: _error => JsxRuntime.jsx(ConversationsPageRelay$ErrorState, {}),
    children: JsxRuntime.jsx(LoggedInAgent.Provider.make, {
      children: JsxRuntime.jsx(ConversationsPageRelay$Page, {
        slug: Stdlib_Option.flatMap(Primitive_option.fromNullable(props.slug), __x => __x[0])
      })
    }),
    onError: error => Sentry.captureException(error, "ConversationsPageRelay.res", undefined, undefined, undefined)
  });
}

let make = ConversationsPageRelay;

exports.SelectedConversation = SelectedConversation;
exports.Query = Query;
exports.Page = Page;
exports.ErrorState = ErrorState;
exports.make = make;
/* use Not a pure module */
